var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('ModalDialog',{attrs:{"title":"建立對戰","hide-cancel":true,"confirm-text":"建立對局","value":_vm.value},on:{"input":_vm.onInput,"confirm":_vm.createLobby}},[_c('LobbyCreateForm',{ref:"lobbyCreateForm"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }